import { AppState } from 'Store'
import { createSelector } from 'reselect'

const documentsLoading = (state: AppState) => state.iBro.requests.bgDocument.documentsLoading
const selectDocumentsLoading = createSelector(documentsLoading, (kinds) => new Set(kinds))

export const bgDocumentSelector = {
	selectDocumentsLoading,
}
